import * as ActionTypes from './action-types';

function canvasReset(state) {
  return {
    ...state,
    hasDrawn: false,
  };
}

function canvasStart(state) {
  return {
    ...state,
    hasDrawn: true,
    isDrawing: true,
  };
}

function canvasStop(state) {
  return {
    ...state,
    isDrawing: false,
    isDragging: false,
  };
}

const Reducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.CANVAS_RESET:
      return canvasReset(state);
    case ActionTypes.CANVAS_START:
      return canvasStart(state, action.payload);
    case ActionTypes.CANVAS_STOP:
      return canvasStop(state);
    default:
      return state;
  }
};

export default Reducer;
